export enum Environments {
  DEVELOPMENT = 'dev',
  TEST = 'test',
  QA = 'qa',
  STG = 'stg',
  PROD = 'prod',
}
